const SearchPatientN = () =>
  import(
    "@/components/dashboard/doctor/searchPatient/searchPatientN"
  );
// const Reviews = () =>
//     import("@/components/dashboard/doctor/Reviews.vue");
const OpinionPoll = () =>
  import("@/components/dashboard/doctor/ComingSoon");
const Appointments = () =>
  import("@/components/dashboard/doctor/AppointmentsMain");
// import OnlineConsultation from "@/components/dashboard/doctor/OnlineConsultation";
const Grievances = () =>
  import("@/components/dashboard/doctor/ComingSoon");
const SetAlerts = () =>
  import("@/components/dashboard/doctor/SetAlerts");
const Accounts = () =>
  import("@/components/dashboard/doctor/Accounts");
const Prescriptions = () =>
  import("@/components/dashboard/doctor/Prescriptions");
const DoctorHomeVisit = () =>
  import("./../../components/dashboard/doctor/HomeVisit/DoctorHomeVisit");
const ComingSoon = () =>
  import("@/components/dashboard/doctor/ComingSoon");
const MyWallet = () =>
  import("@/components/dashboard/doctor/MyWallet");
const Gallery = () =>
  import("@/components/dashboard/doctor/DoctorGallery");
import GalleryRoutes from "@/routes/dashboard/DoctorGallery";
const Documents = () =>
  import("@/components/dashboard/doctor/myDocuments/myDocuments");
const Orders = () =>
  import("@/components/dashboard/doctor/ComingSoon");
const MedicalCalculators = () =>
  import("@/components/dashboard/doctor/ComingSoon");
const Favourites = () =>
  import("@/components/dashboard/doctor/favourites/Favourites");
const Reports = () =>
  import("@/components/dashboard/doctor/Reports");
const PatientGallery = () =>
  import("@/components/dashboard/doctor/DoctorPatientGallery");
const PatientGalleryDetail = () =>
  import("@/components/dashboard/doctor/PatientGalleryDetail");
const RedFlag = () =>
  import("@/components/dashboard/doctor/Flag/RedFlag");
const certificateDetailList = () =>
  import("@/components/dashboard/doctor/myDocuments/certificateDetailList");
const consentFormDetailList = () =>
  import("@/components/dashboard/doctor/myDocuments/consentFormDetailList");
const FavouritesDoctor = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesDoctor");
const FavouritesAmbulance = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesAmbulance");
const FavouritesDiagnostics = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesDiagnostics");
const FavouritesPharmacy = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesPharmacy");
const FavouritesBloodbank = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesBloodbank");
const DashboardRating = () =>
  import("@/components/dashboard/doctor/DashboardRating");
// const onlineConsultationMain = () =>
//   import(
//     "@/components/dashboard/doctor/onlineConsultation/onlineConsultationMain"
//   );
const searchMedicineListing = () =>
  import("@/components/dashboard/doctor/searchMedicine/searchMedicineListing");
const onlineConsultationMain = () =>
  import(
    "@/components/newOC/doctorOC/doctorOC"
  );
const templateListing = () =>
  import(
    "@/components/dashboard/doctor/templates/templateListing"
  );
const Dashboard = () => import("@/components/dashboardNew/doctorDashboard.vue");

export default [
  {
    path: "",
    name: "dashboard.doctor.root",
    redirect: {
      name: "doctorDashboard"
    }
  },
  {
    path: "dashboard",
    name: "doctorDashboard",
    component: Dashboard
  },
  {
    path: "appointments",
    name: "dashboard.doctor.appointments",
    component: Appointments
    // children: appointmentRoutes
  },
  {
    path: "doctor-assist",
    name: "dashboard.doctor.doctor-assist",
    component: Appointments
    // children: assistAppointmentRoutes
  },
  {
    path: "search-patient",
    name: "dashboard.doctor.search-patient",
    component: SearchPatientN
  },
  {
    path: "template",
    name: "dashboard.doctor.template",
    component: templateListing
  },
  {
    path: "reports",
    name: "dashboard.doctor.reports",
    component: Reports
  },
  {
    path: "prescriptions",
    name: "dashboard.doctor.prescriptions",
    component: Prescriptions
  },
  {
    path: "home-visit",
    name: "dashboard.doctor.HomeVisit.DoctorHomeVisit",
    component: DoctorHomeVisit
  },
  {
    path: "reviews",
    name: "dashboard.doctor.reviews",
    component: DashboardRating
  },
  {
    path: "opinion-poll",
    name: "dashboard.doctor.opinion-poll",
    component: OpinionPoll
  },
  {
    path: "online-consultation",
    name: "dashboard.doctor.online-consultation",

    component: onlineConsultationMain
  },
  {
    path: "grievances",
    name: "dashboard.doctor.grievances",
    component: Grievances
  },
  {
    path: "set-alerts",
    name: "dashboard.doctor.set-alerts",
    component: SetAlerts
  },
  {
    path: "accounts",
    name: "dashboard.doctor.accounts",
    component: Accounts
  },
  {
    path: "my-wallet",
    name: "dashboard.doctor.myWallet",
    component: MyWallet
  },
  {
    path: "ipd",
    name: "dashboard.doctor.ipd",
    component: ComingSoon
  },
  {
    path: "my-events",
    name: "dashboard.doctor.my-events",
    component: ComingSoon
  },
  {
    path: "gallery",
    name: "dashboard.doctor.gallery",
    component: Gallery,
    children: GalleryRoutes,
    redirect: {
      name: "dashboard.doctor.gallery.images"
    }
    // children: [{
    //     path: "DoctorMyGallery",
    //     name: "dashboard.doctor.DoctorMyGallery",
    //     component: DoctorMyGallery
    // }]
  },
  {
    path: "patient-gallery",
    name: "dashboard.doctor.patient-gallery",
    component: PatientGallery
  },
  {
    path: "patientGalleryDetail",
    name: "dashboard.doctor.patientGalleryDetail",
    component: PatientGalleryDetail,
    params: true
  },

  {
    path: "myDocuments",
    name: "dashboard.doctor.myDocuments",
    component: Documents
  },
  {
    path: "myOrders",
    name: "dashboard.doctor.myOrders",
    component: Orders
  },

  {
    path: "RedFlag",
    name: "dashboard.doctor.RedFlag",
    component: RedFlag
  },
  {
    path: "medicalCalculators",
    name: "dashboard.doctor.medicalCalculators",
    component: MedicalCalculators
  },

  {
    path: "certificateDetailList",
    name: "dashboard.doctor.certificateDetailList",
    component: certificateDetailList
  },
  {
    path: "consentFormDetailList",
    name: "dashboard.doctor.consentFormDetailList",
    component: consentFormDetailList
  },
  {
    path: "searchMedicine",
    name: "dashboard.doctor.searchMedicineListing",
    component: searchMedicineListing
  },
  {
    path: "favourites",
    name: "dashboard.doctor.favourites",
    component: Favourites,
    redirect: {
      name: "dashboard.doctor.favourites.doctor"
    },
    children: [
      {
        path: "doctor",
        name: "dashboard.doctor.favourites.doctor",
        component: FavouritesDoctor
      },
      {
        path: "ambulance",
        name: "dashboard.doctor.favourites.ambulance",
        component: FavouritesAmbulance
      },
      {
        path: "diagnostics-lab",
        name: "dashboard.doctor.favourites.diagnostics-lab",
        component: FavouritesDiagnostics
      },
      {
        path: "pharmacy",
        name: "dashboard.doctor.favourites.pharmacy",
        component: FavouritesPharmacy
      },
      {
        path: "bloodbank",
        name: "dashboard.doctor.favourites.bloodbank",
        component: FavouritesBloodbank
      }
    ]
  }
];
